import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("vammos-lang") || "en");

  const setLang = useCallback((l) => {
    localStorage.setItem("vammos-lang", l);
    setLangState(l);
  }, []);

  const t = translations[lang];
  // L picks the right string out of a bilingual object { en, gr }
  const L = useCallback((obj) => (obj ? obj[lang] ?? obj.en : ""), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, L }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
